import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGripVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.625,
			cy: 3.875,
			r: 1.375,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.375,
			cy: 3.875,
			r: 1.375,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.625,
			cy: 8,
			r: 1.375,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.375,
			cy: 8,
			r: 1.375,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.625,
			cy: 12.125,
			r: 1.375,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.375,
			cy: 12.125,
			r: 1.375,
			fill: "currentColor"
		})
	]
});
export default SvgGripVertical;
